import { useQuery } from '@tanstack/react-query';
import { fetchQuoteCargoTypesList } from '@views/screens/Quote/data-provider/quote-cargo-types-list';

export const useGetQuoteCargoTypesList = () => {
  return useQuery({
    queryKey: ['quote-cargo-types-list'],
    queryFn: () => fetchQuoteCargoTypesList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
